/* =========================================================
   Clicx Theme — Main JavaScript
   ========================================================= */
'use strict';

(function () {

  /* -------------------------------------------------------
     Theme toggle (dark / light)
  ------------------------------------------------------- */
  const themeToggle = document.getElementById('theme-toggle');
  const html = document.documentElement;

  function setTheme(theme) {
    if (theme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
    try { localStorage.setItem('clicx-theme', theme); } catch (e) {}
  }

  if (themeToggle) {
    themeToggle.addEventListener('click', function () {
      const isDark = html.classList.contains('dark');
      setTheme(isDark ? 'light' : 'dark');
    });
  }

  /* -------------------------------------------------------
     Announcement bar close
  ------------------------------------------------------- */
  const announcementClose = document.querySelector('.announcement-bar__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      const bar = announcementClose.closest('.announcement-bar');
      if (bar) {
        bar.style.display = 'none';
        try { sessionStorage.setItem('clicx-announcement-closed', '1'); } catch (e) {}
      }
    });
    // Restore closed state
    try {
      if (sessionStorage.getItem('clicx-announcement-closed') === '1') {
        const bar = document.querySelector('.announcement-bar');
        if (bar) bar.style.display = 'none';
      }
    } catch (e) {}
  }

  /* -------------------------------------------------------
     Cart Drawer
  ------------------------------------------------------- */
  const cartDrawer = document.getElementById('cart-drawer');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (cartDrawer) {
    // Close on overlay click
    cartDrawer.querySelector('.cart-drawer__overlay').addEventListener('click', closeCartDrawer);
    // Close button
    const closeBtn = cartDrawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  // Intercept cart add forms — show drawer instead of navigating
  document.querySelectorAll('.product-card__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCartCount();
        openCartDrawer();
        refreshCartDrawerContents();
      })
      .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  // Cart sidebar nav link — open drawer
  document.querySelectorAll('.sidebar__nav-item--cart').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (cartDrawer) {
        e.preventDefault();
        refreshCartDrawerContents();
        openCartDrawer();
      }
    });
  });

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function buildCartDrawerHTML(cart) {
    if (cart.item_count === 0) {
      return '<div class="cart-empty">'
        + '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>'
        + '<p>Tu carrito est\u00e1 vac\u00edo</p>'
        + '<a href="/" class="btn-primary">Seguir comprando</a>'
        + '</div>';
    }

    var itemsHTML = '<div class="cart-items">';
    cart.items.forEach(function (item) {
      var imgHTML = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '" alt="' + item.title + '" class="cart-item__image" width="70" height="70" loading="lazy">'
        : '';
      var variantHTML = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item__variant">' + item.variant_title + '</p>'
        : '';
      itemsHTML += '<div class="cart-item">'
        + '<a href="' + item.url + '">' + imgHTML + '</a>'
        + '<div class="cart-item__info">'
        + '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>'
        + variantHTML
        + '<div class="cart-item__actions">'
        + '<div class="quantity-selector">'
        + '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '">-</button>'
        + '<span class="qty-value">' + item.quantity + '</span>'
        + '<button class="qty-btn" data-action="increase" data-key="' + item.key + '">+</button>'
        + '</div>'
        + '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>'
        + '</div>'
        + '</div>'
        + '<button class="cart-item__remove" data-key="' + item.key + '" aria-label="Eliminar">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>'
        + '</button>'
        + '</div>';
    });
    itemsHTML += '</div>';

    var footerHTML = '<div class="cart-footer">'
      + '<div class="cart-subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>'
      + '<a href="/checkout" class="btn-primary btn-checkout">Ir al checkout</a>'
      + '<a href="/cart" class="btn-secondary">Ver carrito</a>'
      + '</div>';

    return itemsHTML + footerHTML;
  }

  function refreshCartDrawerContents() {
    if (!cartDrawer) return;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = cartDrawer.querySelector('.cart-drawer__body');
        if (body) body.innerHTML = buildCartDrawerHTML(cart);
        // Update badge count
        document.querySelectorAll('.sidebar__badge:not(.sidebar__badge--pink)').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.sidebar__badge:not(.sidebar__badge--pink)').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  /* -------------------------------------------------------
     Add to cart — product page
  ------------------------------------------------------- */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = productForm.querySelector('.btn-add-to-cart');
      const originalText = btn ? btn.innerHTML : '';
      if (btn) {
        btn.innerHTML = 'Agregando...';
        btn.disabled = true;
      }
      const data = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCartDrawerContents();
        openCartDrawer();
        if (btn) {
          btn.innerHTML = '✓ Agregado';
          setTimeout(function () {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 2000);
        }
      })
      .catch(function () {
        if (btn) {
          btn.innerHTML = originalText;
          btn.disabled = false;
        }
      });
    });
  }

  /* -------------------------------------------------------
     Quantity selectors (cart page + product page)
  ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const action = btn.dataset.action;
    const key = btn.dataset.key;

    // Product page — update input
    const input = btn.closest('.product-form__qty, .quantity-selector')
      ? btn.closest('.product-form__qty, .quantity-selector').querySelector('.qty-input, .qty-value')
      : null;

    if (input) {
      let val = parseInt(input.value || input.textContent, 10) || 1;
      if (action === 'increase') val++;
      if (action === 'decrease') val = Math.max(1, val - 1);
      if (input.tagName === 'INPUT') { input.value = val; }
      else { input.textContent = val; }
    }

    // Cart — update quantity via API
    if (key) {
      const qtyEl = btn.closest('.cart-item, .quantity-selector')
        ? btn.closest('.cart-item, .quantity-selector').querySelector('.qty-value')
        : null;
      let qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      if (action === 'increase') qty++;
      if (action === 'decrease') qty = Math.max(0, qty - 1);
      if (qtyEl) qtyEl.textContent = qty;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCartDrawerContents(); });
    }
  });

  /* -------------------------------------------------------
     Remove from cart
  ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest('.cart-item__remove');
    if (!removeBtn) return;
    const key = removeBtn.dataset.key;
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (r) { return r.json(); })
    .then(function () { location.reload(); });
  });

  /* -------------------------------------------------------
     Product gallery thumbnails
  ------------------------------------------------------- */
  function activateGallerySlide(container, idx) {
    container.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
    container.querySelectorAll('.product-gallery__slide').forEach(function (s) { s.classList.remove('active'); });
    const targetThumb = container.querySelector('.product-gallery__thumb[data-index="' + idx + '"]');
    const targetSlide = container.querySelector('.product-gallery__slide[data-index="' + idx + '"]');
    if (targetThumb) targetThumb.classList.add('active');
    if (targetSlide) targetSlide.classList.add('active');
  }

  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const container = thumb.closest('.product-gallery');
    if (!container) return;
    activateGallerySlide(container, parseInt(thumb.dataset.index, 10));
  });

  /* -------------------------------------------------------
     Product image zoom lightbox (desktop click + mobile pinch)
  ------------------------------------------------------- */
  const lightbox = document.getElementById('product-img-lightbox');
  if (lightbox) {
    const lbImg = lightbox.querySelector('.img-lightbox__img');
    const lbStage = lightbox.querySelector('.img-lightbox__stage');
    const lbPrev = lightbox.querySelector('.img-lightbox__nav--prev');
    const lbNext = lightbox.querySelector('.img-lightbox__nav--next');
    let lbSlides = [];
    let lbIndex = 0;

    function loadSlide(idx) {
      if (!lbSlides.length) return;
      lbIndex = (idx + lbSlides.length) % lbSlides.length;
      const img = lbSlides[lbIndex];
      lbImg.src = img.dataset.zoomSrc || img.src;
      lbImg.alt = img.alt || '';
      lightbox.classList.remove('is-zoomed');
      if (lbStage) { lbStage.scrollTop = 0; lbStage.scrollLeft = 0; }
      const showNav = lbSlides.length > 1;
      lbPrev.hidden = !showNav;
      lbNext.hidden = !showNav;
    }

    function openLightbox(fromImg) {
      const gallery = fromImg.closest('.product-gallery');
      lbSlides = gallery
        ? Array.from(gallery.querySelectorAll('.product-gallery__image'))
        : [fromImg];
      const startIdx = lbSlides.indexOf(fromImg);
      loadSlide(startIdx >= 0 ? startIdx : 0);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open', 'is-zoomed');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lbImg.removeAttribute('src');
    }

    document.addEventListener('click', function (e) {
      const img = e.target.closest('.product-gallery__image');
      const hint = e.target.closest('.product-gallery__zoom-hint');
      if (img) {
        e.preventDefault();
        openLightbox(img);
        return;
      }
      if (hint) {
        const gallery = hint.closest('.product-gallery');
        const active = gallery && gallery.querySelector('.product-gallery__slide.active .product-gallery__image');
        if (active) { e.preventDefault(); openLightbox(active); }
      }
    });

    lightbox.querySelector('.img-lightbox__close').addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lbStage) closeLightbox();
    });

    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); loadSlide(lbIndex - 1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); loadSlide(lbIndex + 1); });

    lbImg.addEventListener('click', function (e) {
      e.stopPropagation();
      const isZoomed = lightbox.classList.toggle('is-zoomed');
      if (isZoomed && lbStage) {
        const rect = lbImg.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;
        requestAnimationFrame(function () {
          lbStage.scrollLeft = (lbStage.scrollWidth - lbStage.clientWidth) * x;
          lbStage.scrollTop = (lbStage.scrollHeight - lbStage.clientHeight) * y;
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') loadSlide(lbIndex - 1);
      else if (e.key === 'ArrowRight') loadSlide(lbIndex + 1);
    });
  }

  /* -------------------------------------------------------
     Product variant selector (handles both text + color swatches)
  ------------------------------------------------------- */
  const variantInput = document.getElementById('product-variant-id');

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-option__value, .product-option__color-swatch');
    if (!btn) return;
    const pos = btn.dataset.optionPosition;
    const val = btn.dataset.optionValue;

    // Deselect siblings in same option group
    document.querySelectorAll(
      '[data-option-position="' + pos + '"]'
    ).forEach(function (b) { b.classList.remove('selected'); });
    btn.classList.add('selected');

    // Update label text
    const labelVal = document.querySelector('.product-option__selected-value[data-option="' + pos + '"]');
    if (labelVal) labelVal.textContent = val;

    updateSelectedVariant();
  });

  function updateSelectedVariant() {
    if (!variantInput) return;
    // Build selected options map
    var selectedOptions = {};
    document.querySelectorAll('[data-option-position].selected').forEach(function (btn) {
      selectedOptions[btn.dataset.optionPosition] = btn.dataset.optionValue;
    });
    // Fetch product JSON to find matching variant
    var productHandle = document.querySelector('[data-product-handle]');
    var handle = productHandle ? productHandle.dataset.productHandle : null;
    if (!handle) {
      // Try to get handle from URL
      var pathParts = window.location.pathname.split('/');
      var prodIdx = pathParts.indexOf('products');
      handle = prodIdx >= 0 ? pathParts[prodIdx + 1] : null;
    }
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var optionCount = product.options.length;
        var match = product.variants.find(function (v) {
          for (var i = 1; i <= optionCount; i++) {
            if (selectedOptions[String(i)] && v['option' + i] !== selectedOptions[String(i)]) return false;
          }
          return true;
        });
        if (match && variantInput) {
          variantInput.value = match.id;
          // Update price display
          var priceEl = document.querySelector('.product-info__price');
          if (priceEl && match.price) {
            priceEl.textContent = formatMoney(match.price);
          }
          // Toggle availability
          var addBtn = document.querySelector('.btn-add-to-cart');
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.textContent = match.available ? 'Agregar al carrito' : 'Sin stock';
          }
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('es-UY', { minimumFractionDigits: 2 });
  }

  /* -------------------------------------------------------
     Buy now button
  ------------------------------------------------------- */
  var buyNowBtn = document.getElementById('btn-buy-now');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var form = document.getElementById('product-form');
      if (!form) return;
      var varId = document.getElementById('product-variant-id');
      var qty = form.querySelector('.qty-input');
      if (varId) {
        window.location.href = '/checkout?variantId=' + varId.value + '&quantity=' + (qty ? qty.value : 1);
      }
    });
  }

  /* -------------------------------------------------------
     Wishlist (localStorage)
  ------------------------------------------------------- */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('clicx-wishlist') || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem('clicx-wishlist', JSON.stringify(list)); } catch (e) {}
  }
  function syncWishlistUI() {
    const list = getWishlist();
    document.querySelectorAll('[data-product-handle]').forEach(function (el) {
      if (list.includes(el.dataset.productHandle)) el.classList.add('active');
      else el.classList.remove('active');
    });
    // Sidebar "Guardados" badge
    document.querySelectorAll('[data-saved-badge]').forEach(function (b) {
      if (list.length > 0) {
        b.textContent = list.length;
        b.hidden = false;
      } else {
        b.textContent = '0';
        b.hidden = true;
      }
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.productHandle;
    const list = getWishlist();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    setWishlist(list);
    syncWishlistUI();
    // If we're on the saved page, re-render
    if (document.getElementById('saved-products-grid')) renderSavedPage();
  });

  // Cross-tab sync
  window.addEventListener('storage', function (e) {
    if (e.key === 'clicx-wishlist') {
      syncWishlistUI();
      if (document.getElementById('saved-products-grid')) renderSavedPage();
    }
  });

  syncWishlistUI();

  /* -------------------------------------------------------
     Saved products page (renders from localStorage)
  ------------------------------------------------------- */
  function moneyFmt(cents) {
    const n = (cents / 100).toLocaleString('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '$' + n;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildSavedCard(p) {
    const compare = p.compare_at_price && p.compare_at_price > p.price;
    const img = p.featured_image
      ? '<img class="product-card__image" src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
      : '<div class="product-card__image-placeholder"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
    const badge = compare
      ? '<span class="product-card__badge product-card__badge--sale">-' + Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) + '%</span>'
      : '';
    const prices = compare
      ? '<span class="product-card__price product-card__price--sale">' + moneyFmt(p.price) + '</span><s class="product-card__price product-card__price--compare">' + moneyFmt(p.compare_at_price) + '</s>'
      : '<span class="product-card__price">' + moneyFmt(p.price) + '</span>';
    const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
    const vendor = p.vendor ? '<span class="product-card__vendor">' + escapeHtml(p.vendor) + '</span>' : '';
    return '' +
      '<article class="product-card" data-product-id="' + p.id + '">' +
        '<a href="' + p.url + '" class="product-card__image-link" tabindex="-1" aria-hidden="true">' +
          '<div class="product-card__image-wrap">' + img + badge +
            '<button class="product-card__wishlist active" aria-label="Quitar de guardados" data-product-handle="' + escapeHtml(p.handle) + '">' +
              '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
            '</button>' +
          '</div>' +
        '</a>' +
        '<div class="product-card__info">' +
          '<a href="' + p.url + '" class="product-card__title">' + escapeHtml(p.title) + '</a>' + vendor +
          '<div class="product-card__price-row">' +
            '<div class="product-card__prices">' + prices + '</div>' +
            (variantId
              ? '<form action="/cart/add" method="post" class="product-card__form">' +
                  '<input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="1">' +
                  '<button type="submit" class="product-card__add-btn" aria-label="Agregar al carrito">' +
                    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
                  '</button>' +
                '</form>'
              : '') +
          '</div>' +
        '</div>' +
      '</article>';
  }

  function renderSavedPage() {
    const grid = document.getElementById('saved-products-grid');
    if (!grid) return;
    const list = getWishlist();
    const summary = document.querySelector('[data-saved-summary]');
    if (list.length === 0) {
      grid.classList.add('saved-page__grid--empty');
      grid.innerHTML =
        '<div class="saved-page__empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
          '<p>' + escapeHtml(grid.dataset.emptyText || '') + '</p>' +
          '<a href="' + (grid.dataset.exploreUrl || '/collections/all') + '" class="btn-primary">' + escapeHtml(grid.dataset.exploreLabel || 'Explorar') + '</a>' +
        '</div>';
      if (summary) summary.textContent = '0 productos guardados';
      return;
    }
    grid.classList.remove('saved-page__grid--empty');
    grid.innerHTML = '<div class="saved-page__loading">Cargando tus guardados…</div>';

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      const valid = products.filter(Boolean);
      // Prune handles that no longer exist
      const validHandles = valid.map(function (p) { return p.handle; });
      const cleaned = list.filter(function (h) { return validHandles.indexOf(h) !== -1; });
      if (cleaned.length !== list.length) setWishlist(cleaned);
      if (summary) summary.textContent = valid.length + (valid.length === 1 ? ' producto guardado' : ' productos guardados');
      if (valid.length === 0) { renderSavedPage(); return; }
      grid.innerHTML = valid.map(buildSavedCard).join('');
      syncWishlistUI();
    });
  }

  if (document.getElementById('saved-products-grid')) renderSavedPage();

  /* -------------------------------------------------------
     Collection sort
  ------------------------------------------------------- */
  const sortSelect = document.querySelector('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* -------------------------------------------------------
     Smooth section transitions
  ------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.product-card, .collection-card').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      observer.observe(el);
    });
  }

})();
